import { palette } from '../../theme';

export const mobileFilterCalendarModalStyles = {
  mobileModalDatePicker: (screenWidth: number, popUpHeight: number) => ({
    width: screenWidth,
    height: popUpHeight,
    backgroundColor: palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
  }),

  pbiFilterTimelinePlaceHolder: {
    width: '100%',
    minHeight: '66px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  datePickerPlaceHolder: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },

  todayButtonPlaceHolder: (popUpHeight: number, height: number) => ({
    width: '100%',
    minHeight: `${height}px`,
    position: 'absolute',
    top: `${popUpHeight - height}px`,
    background: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(6px)',
    borderTop: `1px solid ${palette.grey[300]}`,
  }),

  todayButton: {
    width: '100%',
    height: '56px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: palette.primary.main,
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '24px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    '&:focus': {
      backgroundColor: '#edf7ff',
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },

  popUpBase: {
    position: 'absolute' as 'absolute',
    top: 0,
  },
};
